import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import OrderPage from "../components/pages/order/OrderPage";
import {
  ICreateOrderPayload,
  IGetQueryParams,
  IUpdateOrderPayload,
  IUpdateOrderStatusPayload,
} from "../interfaces/Index";

export const mapStateToProps = (state: any, props: any) => {
  return {
    isLoading: state.orders.isLoading,
    isError: state.orders.isError,
    error: state.orders.error,
    isOrderCreated: state.orders.isOrderCreated,
    orders: state.orders.orders,
    pagination: state.orders.pagination,
    isOrderUpdated: state.orders.isOrderUpdated,
    isFetchOrderLoading: state.orders.isFetchOrderLoading,
    isFetchOrderError: state.orders.isFetchOrderError,
    orderDetails: state.orders.orderDetails,
    isOrderDetailsFetched: state.orders.isOrderDetailsFetched,
    isOrderStatusUpdated: state.orders.isOrderStatusUpdated,
    customerDetailsNew: state.customer.customerDetailsNew,
    bulkCustomerDetails: state.customer.bulkCustomerDetails,
    isPromosForOrderFetched: state.orders.isPromosForOrderFetched,
    promosForOrder: state.orders.promosForOrder,
    orderPriceBreakdown: state.orders.orderPriceBreakdown,
    isOrderPriceBreakdownFetched: state.orders.isOrderPriceBreakdownFetched,
    userCreditPlan: state.orders.userCreditPlan,
    creditPaymentPlans: state.orders.creditPaymentPlans,
    userCreditStatus:state.orders.userCreditStatus
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    createOrder: (payload: ICreateOrderPayload) =>
      dispatch(actions.createOrder(payload)),
    fetchOrders: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getOrders(queryPrams)),
    getOrderDetails: (id: string) => dispatch(actions.getOrderDetails(id)),
    clearOrderDetails: () => dispatch(actions.clearOrderDetailsAction()),
    updateOrder: (id: string, payload: IUpdateOrderPayload) =>
      dispatch(actions.updateOrder(id, payload)),
    updateOrderStatus: (id: string, payload: IUpdateOrderStatusPayload) =>
      dispatch(actions.updateOrderStatus(id, payload)),
    getBulkCustomerDetailsByIdAction: (ids: string[]) =>
      dispatch(actions.getBulkCustomerDetailsByIdAction(ids)),
    clearBulkCustomerDetailsNewAction: () =>
      dispatch(actions.clearBulkCustomerDetailsAction()),
    getPromosForOrder: () => dispatch(actions.getPromosForOrder()),
    getOrderPriceBreakdown: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getOrderPriceBreakdown(queryPrams)),
    fetchUserCreditLimit: (userId: string) =>
      dispatch(actions.fetchUserCreditLimit(userId)),
    fetchCreditPaymentPlans: (channelType: string, userId: string) =>
      dispatch(actions.fetchCreditPaymentPlans(channelType, userId)),
    clearCreditLimitAndPlansAction: () =>
      dispatch(actions.clearCreditLimitAndPlansAction()),
    fetchCreditUser: (userId: string) =>
      dispatch(actions.fetchCreditUser(userId)),
  };
};

const OrderContainer = connect(mapStateToProps, mapDispatchToProps)(OrderPage);
export default OrderContainer;
